<script setup lang="ts">
import { computed } from 'vue';
import { useSdk } from '@fondationcss/sdk';
import { GricsApiDiagnostics, getGricsSdk } from '@fondationcss/grics';

defineOptions({ name: 'GricsApiPanel' });

const { fetchWrapper } = useSdk();

// The GRICS SDK is a thin wrapper over the shared fetchWrapper, so it carries the session's own
// authentication; the gateway credentials never reach the browser.
const gricsSdk = computed(() => getGricsSdk(fetchWrapper));
</script>

<template>
  <GricsApiDiagnostics :sdk="gricsSdk" />
</template>
